import { render, staticRenderFns } from "./NormalSearchNav56.vue?vue&type=template&id=5c5478c2&scoped=true"
import script from "./NormalSearchNav56.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav56.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5478c2",
  null
  
)

export default component.exports